/** DNI: solo letras y números al guardar; puntos solo al mostrar si es numérico. */

export function normalizeDni(value, maxLen = 20) {
  let s = String(value ?? '').trim();
  if (!s) return '';
  if (/^[0-9.]+$/.test(s)) {
    s = s.replace(/\./g, '');
  }
  s = s.replace(/[^A-Za-z0-9]/g, '');
  return s.slice(0, maxLen);
}

/** 35136461 → 35.136.461; si tiene letras, no modifica. */
export function formatDni(value) {
  const s = String(value ?? '').trim();
  if (!s) return '';
  if (!/^\d+$/.test(s)) return s;
  const parts = [];
  let rest = s;
  while (rest.length > 0) {
    parts.unshift(rest.slice(-3));
    rest = rest.slice(0, -3);
  }
  return parts.join('.');
}
